module.exports = __webpack_public_path__ + "static/media/socourt-logo.fb9611d1.svg";